export default __webpack_public_path__ + "static/media/prf.6192e558.png";